import ko from 'knockout';

export default class ViewModel {
  constructor({
    i18n,
  }) {
    this.i18n = i18n;
    this.reachSize = ko.observable('');
  }

  updateAttribute({
    reachSize,
  }) {
    this.reachSize(this.i18n.getString('Audience_Reach_Size', {
      reachSize: reachSize || this.i18n.getString('Contextual_Response_Null'),
    }));
  }
}
